export const rules ={
    type: [
      { required: true, message: "请选择类型!", trigger: "change" },
    ],
        name: [
        { required: true, message: "请输入场馆名!", trigger: "blur" },
      ],
     
    }